import { _catchError } from './diff/catch-error';

/** @type {import('./internal').Options}  */
const options = {
	_catchError
};

export default options;
